import { useState, useEffect } from "react";

export const ChooseImageType = ({type, sendPhotoTypetoParent}) => {
    let [isActive, setIsActive] = useState(type);

    function handleImageType(val) {
        sendPhotoTypetoParent(val);
    }

    return(
        <>
            <p className="whiteText">Set image type:</p>
            <button 
                value="qc" 
                onClick={e => {handleImageType(e.target.value)}}
                
            >qc</button>
            <button 
                value="dr" 
                onClick={e => handleImageType(e.target.value)} 
            >ldr</button>
        </>
    );
}

export const CustomSlideSize = ({ sendArraySizetoParent }) => {
    const [slideSize, setSlideSize] = useState(5);

    function handleSizeChange(val) {
        setSlideSize(val);
        sendArraySizetoParent(val);
    }
    
    

    return(
        <>
        <p className="whiteText" >Set number of images in slideshow:</p>
            <input 
                type="number"
                style={{marginRight: '10px'}}
                value={slideSize}
                onChange={e => handleSizeChange(e.target.value)}    
            />
        </>
    );
}

export const Slideshow = ({images, size, type, index, interval, thumbnailId, playStopId, sendLastImgMessageToParent}) => {
    const [buttonText, setButtonText] = useState("Play");
    let [newImages, setNewImages] = useState(Object.values(images).filter((element, index) => {
        if(element.substring(element.length - 6, element.length - 4) === type) {
            return element;
        }
    }));
    let [newIndex, setNewIndex] = useState(newImages.length - 6);
    let [i, setIterator] = useState(newIndex);

    useEffect(() => {
        let newImagesArr = Object.values(images).filter((element, index) => {
            if(element.substring(element.length - 6, element.length - 4) === type) {
                return element;
            }
        });
        setNewImages(newImagesArr);
    }, [type]);
    
    useEffect(() => {
        if(Object.values(newImages).includes(images[index])) {
            setNewIndex(newImages.indexOf(images[index]));
            setIterator(newImages.indexOf(images[index]));
        } else {
            setIterator(index);
        }

        console.log(newIndex);
    }, [index]);
    
    //set loop

    setTimeout(() => {
        if(buttonText === "Stop") {
            if(i >= Number(newIndex) + Number(size) - 1 ) {
                setIterator(newIndex);
            } else {
                setIterator(++i);
            }
        }
    }, interval);

    function handleLastImgButtonClick(val) {
        sendLastImgMessageToParent(val);
    }

    return (
        <section className="slideshow">
            
            <div className="slide-holder">
                <section className="slide current-slide">
                    <div className="slide-thumbnail">
                        <img id={thumbnailId} src={'/par/webImages/' + newImages[i]}  alt=""/>
                    </div>
                </section>
            </div>
            <div className="slideshow-controller">
                {/* <span onClick={() => setIterator(0)}> |&lt; </span>*/}
                <button onClick={() => {
                    if(i > 2) {
                        setIterator(--newIndex);
                    } else {
                        setIterator(Object.values(newImages).length - 1);
                    }
                }} >&lt; Prev</button>
                <button id={playStopId} onClick={() => {
                    if(buttonText === "Play") {
                        setButtonText("Stop");
                    } else {
                        setButtonText("Play");
                    }
                }}>{ buttonText }</button>
                <button onClick={() => {
                    if(i > Object.values(newImages).length - 2) {
                        setIterator(2);
                    } else {
                        setIterator(++newIndex);
                    }

                }} >Next &gt;</button>
                <button value="1" onClick={(e) => {
                    handleLastImgButtonClick(e.target.value);
                }}>Return to most recent data &gt;&gt;</button>
            </div>
            
        </section>
    );
}



/*const Slideshow = ({images, interval, thumbnailId, playStopId}) => {
    const [buttonText, setButtonText] = useState("Play");
    let [i, setIterator] = useState(0);

    


    //set loop

    setTimeout(() => {
        if(buttonText === "Stop") {
            if(i === images.length - 1) {
                setIterator(0);
            } else {
                setIterator(i + 1);
            }

        }
    }, interval);
    

    return (
        <section className="slideshow">
            <div className="slide-holder">
                <section className="slide current-slide">
                    <div className="slide-thumbnail">
                        <img id={thumbnailId} src={'imgs/' + images[i]}  alt=""/>
                    </div>
                </section>
            </div>
            <div className="slideshow-controller">
                {/* <span onClick={() => setIterator(0)}> |&lt; </span>*//*}
                /*<button onClick={() => {
                    if(i >= 0) {
                        setIterator(i--);
                    } else {
                        setIterator(images.length - 1);
                    }
                }} >&lt;&lt;</button>
                <button id={playStopId} onClick={() => {
                    if(buttonText === "Play") {
                        setButtonText("Stop");
                    } else {
                        setButtonText("Play");
                    }
                }}>{ buttonText }</button>
                <button onClick={() => {
                    if(i === images.length) {
                        setIterator(0);
                    } else {
                        setIterator(i++);
                    }

                }} >&gt;&gt;</button>
                {/*<span >&gt;|</span>*//*}
           </div>
        </section>
    );
}*/
